// removed by extract-text-webpack-plugin
module.exports = {"Container":"styles__Container___3Dxad"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FlatsList/FlatsListItem/ViewType/styles.scss
// module id = 1330
// module chunks = 0